import { redirectTo } from 'components/common/navigation/redirect';
import Route from 'enum/route.enum';
import fetchIntercept from 'fetch-intercept';
import { translate as t } from 'utils/i18n';
import ApiUrl from 'enum/api-url.enum';

export const AuthInterceptor = () => {
  fetchIntercept.register({
    request: function (url, config) {
      return [url, config];
    },
    requestError: function (error) {
      return Promise.reject(error);
    },
    response: function (response) {
      if (
        response &&
        response.status === 401 &&
        !(response.url && response.url.includes(ApiUrl.REGISTERDEVICEVERIFICATION)) &&
        response.request?.method !== 'HEAD'
      ) {
        redirectTo(Route.route.DEVICEIPNOTFOUND);
      }
      return response;
    },
    responseError: function (error) {
      if (error && error?.message === 'Failed to fetch') {
        error = { status: 404, data: { details: t('errors.serviceNotAccessible') } };
      }
      return Promise.reject(error);
    },
  });
};
